import React from "react";

type LikeIconProps = {
    className?: string;
    isFavorite?: boolean;
};

const LikeIcon: React.FC<LikeIconProps> = ({ className = "size-4", isFavorite = false }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.83 15.15"
            className={`${className} transition-colors duration-200 ${
                isFavorite ? "text-danger" : "text-gray-600"
            } hover:text-danger`}
            fill="currentColor"
        >
            {isFavorite ? (
                <path d="M8.41,15.15h0c-.28,0-.55-.12-.74-.33L1.2,7.69C-.46,5.87-.39,3.09,1.35,1.35,2.27.42,3.54-.06,4.86,0c1.3.07,2.52.7,3.34,1.72l.22.28.22-.28C9.45.71,10.67.08,11.97,0c1.29-.07,2.58.42,3.51,1.34h0c1.74,1.74,1.81,4.53.15,6.35l-6.48,7.12c-.19.21-.46.33-.74.33Z" />
            ) : (
                <path d="M8.41,15.15h0c-.28,0-.55-.12-.74-.33L1.2,7.69C-.46,5.87-.39,3.09,1.35,1.35,2.27.42,3.54-.06,4.86,0c1.3.07,2.52.7,3.34,1.72l.22.28.22-.28C9.45.71,10.67.08,11.97,0c1.29-.07,2.58.42,3.51,1.34h0c1.74,1.74,1.81,4.53.15,6.35l-6.48,7.12c-.19.21-.46.33-.74.33ZM4.59,2c-.69,0-1.34.27-1.83.76-.98.98-1.02,2.56-.08,3.59l5.74,6.31,5.74-6.31c.94-1.03.9-2.6-.08-3.59-.53-.53-1.24-.8-1.98-.76-.75.04-1.42.39-1.89.97l-1,1.25c-.19.24-.48.38-.78.38h0c-.30,0-.59-.14-.78-.38l-1-1.25c-.47-.59-1.14-.93-1.89-.97-.05,0-.10,0-.15,0Z" />
            )}
        </svg>
    );
};

export default LikeIcon;